export default {
	mounted(el) {
		el.style.cursor = 'pointer'
		el.__originalText = el.innerText
		el.__originalColor = el.style.color

		el.__clickHandler = () => {
			if (el.innerText.includes('Copiado')) return

			const text = el.innerText

			navigator.clipboard.writeText(text).then(() => {
				el.innerHTML = 'Copiado <i class="mdi mdi-check-circle-outline" style="color: green;"></i>'
				el.style.color = 'green'

				setTimeout(() => {
					el.innerText = el.__originalText
					el.style.color = el.__originalColor
				}, 2000)
			})
		}

		el.addEventListener('click', el.__clickHandler)
	},

	beforeUnmount(el) {
		el.removeEventListener('click', el.__clickHandler)
	},
}
